import React from "react";
import Dialog from "src/components/Dialog";
import getDeviceIcon from "src/icons/device/getDeviceIcon";
import resolveText from "./resolveText";

export default class ConfirmationDialog extends React.Component {
  state = {
    isOpen: true,
    isProcessing: false
  };

  render() {
    const { isOpen, isProcessing } = this.state;
    const {
      t,
      request,
      onReject,
      onDeviceLimitExceed,
      onPairingConfirmed,
      togglePurchaseFlow,
      shouldOpenPurchaseFlow
    } = this.props;
    const heading = t(`pairing.responder.confirmationDialog.heading`);
    const text = resolveText({
      t,
      deviceName: request.deviceName,
      familyName: request.familyName,
      pairingType: request.pairingType
    });

    return (
      <Dialog
        isOpen={isOpen}
        buttons={[
          {
            text: t("buttons.reject"),
            onClick: onReject
          },
          {
            text: t("buttons.pair"),
            onClick: shouldOpenPurchaseFlow
              ? () => {
                  onDeviceLimitExceed();
                  togglePurchaseFlow();
                }
              : async () => {
                  try {
                    this.setState({ isProcessing: true });
                    await onPairingConfirmed();
                    this.setState({ isOpen: false, isProcessing: false });
                  } catch (error) {
                    // eslint-disable-next-line no-console
                    console.log(error);
                  }
                }
          }
        ]}
        heading={heading}
        text={text}
        icon={getDeviceIcon(request.from)}
        type="success"
        isProcessing={isProcessing}
      />
    );
  }
}
